/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { createAgent } from '@vlinder-web/plugin-agent-service-react';
import {
  DownloadPolicyPlugin,
  IDownloadPolicyPluginMethods,
  ErrorProvisionalPlugin,
  IErrorProvisionalPluginMethods,
  HeaderProvisionalPlugin,
  IHeaderProvisionalPluginMethods,
  LoadingProvisionalPlugin,
  ILoadingProvisionalPluginMethods,
  ProvisionalListPlugin,
  IProvisionalListPluginMethods,
  SettingsProvisionalPlugin,
  ISettingsProvisionalPluginMethods,
  StaticProvisionalPagePlugin,
  IStaticProvisionalPagePluginMethods,
} from './plugins';

export type TAgent = IDownloadPolicyPluginMethods &
  IErrorProvisionalPluginMethods &
  IHeaderProvisionalPluginMethods &
  ILoadingProvisionalPluginMethods &
  IProvisionalListPluginMethods &
  ISettingsProvisionalPluginMethods &
  IStaticProvisionalPagePluginMethods;

const getPlugins = () => {
  return [
    new StaticProvisionalPagePlugin(),
    new ErrorProvisionalPlugin(),
    new LoadingProvisionalPlugin(),
    //Business logic plugins !
    new DownloadPolicyPlugin(),
    new HeaderProvisionalPlugin(),
    new ProvisionalListPlugin(),
    new SettingsProvisionalPlugin(),
  ];
};

export const getAgent = () => {
  return createAgent<TAgent>({
    plugins: getPlugins(),
  });
};
